import React from "react";
import { Link } from "react-router-dom";

export const Header = () => {
  return (
    <header
      style={{
        width: "100vw",
        background: "#fff",
        padding: 0,
        position: "sticky",
        top: 0,
        zIndex: 200,
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          maxWidth: "1300px",
          margin: "0 auto",
          padding: "0px 2px",
        }}
      >
        {/* Bloque de logos a la izquierda */}
        <div style={{ display: "flex", alignItems: "flex-end", gap: "20px" }}>
          {/* Logo de Lab Demoss enlaza al home */}
          <Link to="/" style={{ display: "block" }}>
            <img
              src="./img/LABDEMOSS.png"
              alt="Logo Lab Demoss"
              style={{
                height: "88px",
                width: "auto",
                objectFit: "contain",
                display: "block",
              }}
            />
          </Link>

          {/* Google Award: clic lleva al artículo externo */}
          <a
            href="https://unamglobal.unam.mx/global_revista/investigadores-de-la-unam-ganan-el-google-academic-research-award-2024/"
            target="_blank"
            rel="noopener noreferrer"
            style={{ display: "block" }}
          >
            <img
              src="./img/GoogleAward.png"
              alt="Google Award"
              style={{
                height: "78px",
                width: "auto",
                objectFit: "contain",
                display: "block",
              }}
            />
          </a>
        </div>
      </div>
    </header>
  );
};
